var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"basic-layout-wrapper"},[_c(_setup.TopHeader),_c(_setup.LeftMenu),_c('div',{staticClass:"layout-content"},[(_setup.isRouterShow)?_c('div',{staticClass:"page-wrapper"},[_c(_setup.BreadCrumb),_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }